<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :items-per-page="10"
    :search="search"
    :loading="loading"
    :loading-text="'Chargement en cours...'"
    item-key="_id"
  />
</template>

<script>
export default {
  name: 'RoleList',
  components: {},
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    search: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headers () {
      const baseHeaders = [
        {
          text: 'Nom',
          align: 'center',
          value: 'name',
        },
      ]
      return baseHeaders
    },
    items () {
      return this.value
    },
  },
}
</script>
